(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	// Create a jQuery Plugin of Masonry
	var jQueryBridget = require('jquery-bridget');
	var Masonry = require('masonry-layout');

	jQueryBridget('masonry', Masonry, $);

	// We need to wait for images to load
	require('imagesloaded');

	// Wrapping element
	var wrapper = $('#posts').find('> div');

	// Only continue if we're on the posts page
	if (wrapper.length) {
		wrapper.imagesLoaded(function () {
			wrapper.masonry({
				itemSelector: 'article',
				percentPosition: true,
				gutter: 16
			});
		});

		// Hijax the pagination
		var nextLink = $('#pagination').find('a[rel=next]');

		nextLink.on('click', function (e) {
			e.preventDefault();

			if (nextLink.is('.icon-spinner')) {
				return;
			}

			nextLink.addClass('icon-spinner');

			$.getJSON(nextLink.attr('href'), function (data) {
				nextLink.removeClass('icon-spinner');

				// Update next link's href
				if (data.next) {
					nextLink.show().attr('href', $(data.next).attr('href'));
				}
				else {
					nextLink.remove();
				}

				// Add new posts
				if (data.posts && data.posts.length) {
					var newPosts = $(data.posts);

					wrapper.append(newPosts);

					wrapper.imagesLoaded(function () {
						wrapper.masonry('appended', newPosts);
					});
				}
			});
		});

		// Auto click on the pagination link when scrolling down
		var endlessScroll = function () {
			var bottomOfPosts = wrapper.offset().top + wrapper.height();
			var bottomOfScreen = $(window).scrollTop() + $(window).height();

			if (bottomOfScreen > bottomOfPosts && nextLink.length && !nextLink.is('.icon-spinner')) {
				nextLink.click();
			}
		};

		endlessScroll();

		$(window).on('scroll', endlessScroll);
	}
})();
